import { render, staticRenderFns } from "./payCont.vue?vue&type=template&id=74153ac0&scoped=true&"
import script from "./payCont.vue?vue&type=script&lang=js&"
export * from "./payCont.vue?vue&type=script&lang=js&"
import style0 from "./payCont.vue?vue&type=style&index=0&id=74153ac0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74153ac0",
  null
  
)

export default component.exports